import { render, staticRenderFns } from "./NotificationAdminTrigger.vue?vue&type=template&id=d7c04caa&scoped=true&"
import script from "./NotificationAdminTrigger.vue?vue&type=script&lang=js&"
export * from "./NotificationAdminTrigger.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAdminTrigger.vue?vue&type=style&index=0&id=d7c04caa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c04caa",
  null
  
)

export default component.exports